import * as React from 'react';

import { PageTitleBar } from 'components';

const CatalogHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { CatalogHeader };
